import React from 'react';

export default function Contact({ t }) {
  return (
    <section id="contact" className="bg-bg-soft border-t border-rule">
      <div className="max-w-content mx-auto px-4 md:px-8 py-16 md:py-24">
        <div className="font-mono text-[13px] tracking-eyebrow uppercase text-ink-3 mb-8">
          05 / {t.nav.contact}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-[1.3fr_1fr] gap-8 md:gap-12 items-end">
          <h2
            className="font-display font-medium text-ink m-0"
            style={{
              fontSize: 'clamp(32px, 6vw, 80px)',
              lineHeight: 1,
              letterSpacing: '-0.035em',
            }}
          >
            {t.contact.title}
          </h2>

          <div>
            <p className="text-ink-2 m-0 mb-6 leading-[1.5]" style={{ fontSize: 17 }}>
              {t.contact.sub}
            </p>

            <div className="flex flex-col gap-0.5">
              <a
                href={`mailto:${t.contact.email}`}
                className="flex items-center justify-between py-3 border-t border-rule no-underline text-ink font-medium hover:text-ink-2 transition-colors duration-150"
              >
                <span>Contact me</span>
                <span className="font-mono text-ink-3">↗</span>
              </a>
              {t.contact.socials.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-between py-3 border-t border-rule no-underline text-ink font-medium hover:text-ink-2 transition-colors duration-150"
                >
                  <span>{s.label}</span>
                  <span className="font-mono text-ink-3">↗</span>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
